/**
 * Lightweight SDK initialization for tree-shakeable usage.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 *
 * @example
 * ```typescript
 * import { initSDK, invoices, customers } from '@spaceinvoices/js-sdk';
 *
 * // Initialize once at app startup
 * initSDK({ accessToken: 'your-api-key' });
 *
 * // Then use individual modules anywhere
 * const result = await invoices.list();
 * ```
 */

import { setFetchConfig } from "../mutator/custom-fetch";
import type { SDKConfig } from "./types";
import { DEFAULT_BASE_URL } from "./types";

/**
 * Initialize the SDK configuration for tree-shakeable module usage.
 * Call this once at app startup before using any API modules.
 */
export function initSDK(config: SDKConfig | string): void {
  const resolvedConfig = typeof config === "string" ? { accessToken: config } : config;

  const getAccessToken =
    typeof resolvedConfig.accessToken === "function"
      ? resolvedConfig.accessToken
      : () => resolvedConfig.accessToken as string;

  setFetchConfig({
    baseUrl: resolvedConfig.basePath ?? DEFAULT_BASE_URL,
    getAccessToken,
    clientName: resolvedConfig.clientName ?? "js-sdk",
    onUnauthorized: resolvedConfig.onUnauthorized,
  });
}
